/**
 * Contract dates are stored as date-only strings ("2026-11-20"). `new Date()`
 * reads those as UTC midnight, which displays as the previous day anywhere
 * west of UTC — every closing date showed a day early in the US. Parse them
 * as local calendar dates instead.
 */
export function parseDateOnly(value?: string | Date | null): Date | null {
  if (!value) return null;
  if (value instanceof Date)
    return Number.isNaN(value.getTime()) ? null : value;
  // Also date-only values that went through a Date and came back as UTC
  // midnight ("2026-03-01T00:00:00.000Z") — same calendar date, no shift.
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.0+)?Z)?$/.exec(
    value.trim()
  );
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Whole calendar days from today (local) until `value`; null if unparseable. */
export function daysUntil(value?: string | Date | null): number | null {
  const d = parseDateOnly(value);
  if (!d) return null;
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86400000);
}
